"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BloodyAuraAbilityHandler = exports.BloodyAuraActorAbilityFactory = exports.BloodyAuraAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const EventType_1 = require("../../core/events/EventType");
const Schedule_1 = require("../../core/Schedule");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
class BloodyAuraAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.BloodyAura;
        this.__typeName = "BloodyAura";
    }
}
exports.BloodyAuraAbilityArgs = BloodyAuraAbilityArgs;
let BloodyAuraActorAbilityFactory = class BloodyAuraActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("BloodyAura", "Self", 0);
    }
};
BloodyAuraActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("BloodyAura")
], BloodyAuraActorAbilityFactory);
exports.BloodyAuraActorAbilityFactory = BloodyAuraActorAbilityFactory;
let BloodyAuraAbilityHandler = class BloodyAuraAbilityHandler {
    init(sequence, container, actorId) {
        container.applyBuff({
            sequence,
            creatorId: actorId,
            targetId: actorId,
            duration: Duration_1.Duration.Permanent,
            effect: new core_1.LinkedEventHandlerEffectArgs("Bloody Aura", "Causes enemies to bleed on turn started", false, container.registerEventHandlerScript(actorId, EventType_1.EventType.TurnStarted, Schedule_1.Schedule.Unlimited, "ApplyEffects_OnEvent", {
                target: Target_1.Target.AllEnemies,
                effects: [
                    {
                        duration: Duration_1.Duration.Turns(2),
                        effect: new core_1.BleedingEffectArgs("Power", 10),
                    }
                ]
            }))
        });
    }
    activate(sequence, container, ability) {
        throw new Error("PASSIVE_ONLY");
    }
};
BloodyAuraAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.BloodyAura)
], BloodyAuraAbilityHandler);
exports.BloodyAuraAbilityHandler = BloodyAuraAbilityHandler;
